import { get, ref, remove, set, update } from "firebase/database";
import { db } from "../lib/firebase";
import { getPathDatabaseByRole } from "./auth";
import { LaunchError } from "../utils/errors";
import { hashStringToID } from "../utils/string";

const getCustomReportPromptsPath = (advertiserID) =>
  `customReportPrompts/${advertiserID}`;

const getCustomReportPromptItemPath = (advertiserID, promptHash) =>
  `${getCustomReportPromptsPath(advertiserID)}/${promptHash}`;

const toPromptList = (data = {}) =>
  Object.entries(data)
    .map(([id, value]) => ({
      id,
      prompt: value?.prompt || "",
      creationTime: value?.creationTime || 0,
      lastUsedAt: value?.lastUsedAt || value?.creationTime || 0,
    }))
    .filter((item) => item.prompt)
    .sort((a, b) => (b.lastUsedAt || 0) - (a.lastUsedAt || 0));

export const startGetCustomReportPrompts = () => async (dispatch) => {
  try {
    const { userID: advertiserID } = dispatch(getPathDatabaseByRole());
    if (!advertiserID) {
      return { ok: false, data: [] };
    }

    const snapshot = await get(
      ref(db, getCustomReportPromptsPath(advertiserID))
    );
    if (!snapshot.exists()) {
      return { ok: true, data: [] };
    }

    return { ok: true, data: toPromptList(snapshot.val()) };
  } catch (error) {
    dispatch(
      LaunchError(error, false, [], {
        functionName: "startGetCustomReportPrompts",
      })
    );
    return { ok: false, data: [] };
  }
};

export const startSaveCustomReportPrompt =
  ({ prompt }) =>
  async (dispatch) => {
    try {
      const { userID: advertiserID } = dispatch(getPathDatabaseByRole());
      const trimmed = String(prompt || "").trim();
      if (!advertiserID || !trimmed) {
        return { ok: false };
      }

      const promptHash = hashStringToID(trimmed);
      const itemRef = ref(
        db,
        getCustomReportPromptItemPath(advertiserID, promptHash)
      );
      const existing = await get(itemRef);
      const now = Date.now();

      if (existing.exists()) {
        await update(itemRef, { lastUsedAt: now });
        return { ok: true, key: promptHash, duplicated: true };
      }

      await set(itemRef, {
        prompt: trimmed,
        creationTime: now,
        creationTimeNegative: -now,
        lastUsedAt: now,
      });

      return { ok: true, key: promptHash, duplicated: false };
    } catch (error) {
      dispatch(
        LaunchError(error, false, [], {
          functionName: "startSaveCustomReportPrompt",
        })
      );
      return { ok: false };
    }
  };

export const startRemoveCustomReportPrompt =
  ({ promptHash }) =>
  async (dispatch) => {
    try {
      const { userID: advertiserID } = dispatch(getPathDatabaseByRole());
      if (!advertiserID || !promptHash) {
        return { ok: false };
      }

      await remove(
        ref(db, getCustomReportPromptItemPath(advertiserID, promptHash))
      );
      return { ok: true };
    } catch (error) {
      dispatch(
        LaunchError(error, false, [], {
          functionName: "startRemoveCustomReportPrompt",
        })
      );
      return { ok: false };
    }
  };
